
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_10m3l_1rp57_103",
  "token": "awsui_token_10m3l_1rp57_108",
  "show-operation": "awsui_show-operation_10m3l_1rp57_123",
  "select": "awsui_select_10m3l_1rp57_129",
  "token-content": "awsui_token-content_10m3l_1rp57_133",
  "dismiss-button": "awsui_dismiss-button_10m3l_1rp57_138",
  "token-disabled": "awsui_token-disabled_10m3l_1rp57_180"
};
  